import { resources } from "@constants/hardcoded-strings";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { Dispatch } from "redux";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { GenericAccountStateTypes } from "@enums/generic-account-state-types";
import { deleteOrganizationRequest } from "@requests/delete-organization";
import { updateOrganizations } from "@redux/actions/organizations-actions";

export const deleteOrganizationReduxRequest = (dispatch: Dispatch) => async (
    organizationId: string
): Promise<AxnCompany> => {
    const { data, error } = await deleteOrganizationRequest(organizationId);
    if (data) {
        displaySuccessModal(
            dispatch,
            resources.requests.deleteOrganization.success.title,
            resources.requests.deleteOrganization.success.message
        );
        dispatch(updateOrganizations(data.transferObject, GenericAccountStateTypes.DELETE));
        return data.transferObject;
    } else {
        if (error) {
            const errorResource = resources.requests.deleteOrganization.error;

            logAndDisplayErrorModal(
                dispatch,
                error,
                errorResource.title,
                errorResource.message
            );
        }
    }

    return null;
};